import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";

import "./animacionSuccessful.css";

export const AnimacionSuccessful = (props) => {
  const errorBoolean = props.errorBool;
  const [showPopup, setShowPopup] = React.useState(false);
  const [variable, setVariable] = React.useState(false);
  const avisomsg = props.avisomsg;
  const refresh = props.refreshPage;

  const showSuccessPopup = () => {
    setShowPopup(true);
    setTimeout(() => {
      setVariable(true);
    }, 500);
  };

  React.useEffect(() => {
    showSuccessPopup();
  }, []);

  return (
    <>
      {showPopup && (
        <Modal
          show={showPopup}
          onHide={() => setShowPopup(false)}
          className="success-popup-modal"
          centered
          size="sm"
        >
          <div className="success-popup px-2 py-4 position-relative">
            {/* Botón de cerrar */}
            <div
              className="position-absolute"
              style={{ top: "1rem", right: "1rem", cursor: "pointer" }}
              onClick={() => setShowPopup(false)}
            >
              <XMarkIcon
                style={{ width: "24px", height: "24px", color: "#6b7280" }}
              />
            </div>

            {/* Ícono */}
            <div
              style={{
                backgroundColor: errorBoolean ? "#fdecea" : "#c2ecd1ff",
                borderRadius: "50%",
                padding: "8px",
                marginBottom: "12px",
              }}
            >
              {variable ? (
                errorBoolean ? (
                  <ExclamationCircleIcon
                    style={{ width: "24px", height: "24px", color: "#d32f2f" }}
                  />
                ) : (
                  <CheckCircleIcon
                    style={{ width: "24px", height: "24px", color: "#108F2E" }}
                  />
                )
              ) : (
                <Spinner animation="border" />
              )}
            </div>

            {/* Título */}
            <h1
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {errorBoolean ? "Error en la operación" : "Operación exitosa"}
            </h1>

            {/* Subtítulo */}
            <p
              style={{
                color: "#555",
                textAlign: "center",
                marginBottom: "1rem",
                width: "100%",
              }}
            >
              {avisomsg}
            </p>

            {/* Botón */}
            {!errorBoolean && (
              <Button
                className="btn btn--primary btn btn-primary btn-accept"
                style={{ width: "140px" }}
                onClick={refresh}
              >
                Aceptar
              </Button>
            )}
          </div>
        </Modal>
      )}
    </>
  );
};

export default AnimacionSuccessful;
